<div class="bg-th-blue mt-0 container-fluid py-2 position-sticky top-0 index-3">
    <div class=" d-flex justify-content-between  align-content-center">
        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>
    </div>
</div>

<h3 class="w-100 text-center mt-2 ">
    لیست تبلیغات</h3>
<div class="col-lg-5 col-md-6 col-10 d-flex  dirI me-auto">
    <div class="col-8">
        <input type="text" class="form-control" placeholder="بر اساس موضوع" (keyup)="filter($event.target)" />

    </div>
    <div class="col-4">
        <button class="btn btn-primary ms-2" data-bs-toggle="modal" data-bs-target="#addModal">ثبت تبلیغ جدید</button>
    </div>

</div>
<div class="col-12 d-flex justify-content-center table-responsive dirI overflow-auto" style="max-height:80vh;">

    <table class="table mt-1 table-responsive overflow-auto dirI table-striped  overflow-auto d-block whitespace" id="excel-table-adds" style="">
        <thead class=" dirI ">
            <tr class="text-center">

                <th scope="col " class=" "># </th>
                <th scope="col " class=" ">عملیات</th>
                <th class="" scope="col">نوع خودرو</th>
                <th class="" scope="col">گروه خودیی </th>
                <th scope="col " class="pointer">حوزه خدمت </th>
                <th scope="col " class="">شامل محدوده </th>
                <th scope="col " class="">حداکثر تعداد پخش</th>
                <th scope="col " class="">متقاضی</th>
                <th scope="col " class="">موضوع </th>
                <th scope="col " class="">ساعت شروع پخش</th>
                <th scope="col " class="">ساعت پایان پخش</th>
                <th scope="col " class="">تاریخ پایان</th>
                <th scope="col " class="">تاریخ شروع</th>
                <th scope="col " class="">نقاط محدوده </th>
                <th scope="col " class="">تعداد مخاطب</th>
                <th scope="col " class="">تعداد پخش</th>
                <th scope="col " class="">مدت تبلیغ</th>
                <th scope="col " class="">موزیک</th>


            </tr>
        </thead>
        <tbody>
            <tr class="text-center  dirI " *ngFor="let item of listTaxiAdds;let i=index ">
                <th class="text-secondary">{{i+1 |faNum}}</th>
                <th class="text-secondary d-flex justify-content-around w-100">
                    <i class="fa fa-edit fa-2x text-warning mx-2 pointer" title="ویرایش" (click)="editeMod(item)" data-bs-toggle="modal" data-bs-target="#addModal"></i>
                    <i class="fa fa-trash fa-2x text-danger mx-2 pointer" title="حذف" (click)="deleteAdds(item.iTaxiADS)"></i>
                    <i class="fa fa-play-circle fa-2x text-primary mx-2 pointer" title="پخش فایل" (click)="getVoice(item.iTaxiADS)"></i>
                    <i class="fa fa-flag fa-2x text-success mx-2 pointer" title="ثبت محدوده" data-bs-toggle="modal" data-bs-target="#Add-station-modal" (click)="newOpenMap(item.iTaxiADS)"></i>
                </th>
                <td class="text-secondary bold">{{item.strGPSType_strComment }}</td>
                <td class="text-secondary bold">{{item.strMobileGroup_strComment }}</td>
                <th class="text-secondary ">{{item.strMobileDomain_strComment}}</th>
                <th class="text-secondary " *ngIf="item.bDoman">ندارد</th>
                <th class="text-secondary " *ngIf="!item.bDoman">دارد</th>
                <th class="text-secondary ">{{item.iMaxPlay|faNum }}</th>
                <th class="text-secondary ">{{item.strApplicant }}</th>
                <th class="text-secondary  ">{{item.strSubject }}</th>
                <th class="text-secondary  ">{{item.strSTime|faNum }}</th>
                <th class="text-secondary  ">{{item.strETime|faNum}}</th>
                <th class="text-secondary  ">{{item.strEDate|faNum}}</th>
                <th class="text-secondary  ">{{item.strSDate|faNum }}</th>
                <th class="text-secondary  ">{{item.geoDomain }}</th>
                <th class="text-secondary  ">{{item.iAudience|faNum }}</th>
                <th class="text-secondary  ">{{item.iPlayed|faNum }}</th>
                <th class="text-secondary  ">{{item.iDuration|faNum }}</th>
                <th class="text-secondary  " *ngIf="item.bMusic">دارد</th>
                <th class="text-secondary  " *ngIf="!item.bMusic">ندارد</th>
            </tr>
        </tbody>
    </table>

</div>






<!-- Modal Wav -->
<div class="modal fade" id="wawModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="exampleModalLabel">پخش فایل</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <audio controls *ngIf="strWaw" class="w-100">
                  <source [src]="('data:audio/wav;base64,'+strWaw | safeUrl)" type="audio/wav">
                  Your browser does not support the audio tag.
                </audio>
            </div>

        </div>
    </div>
</div>








<!--Add-station-Modal-->
<div class="modal fade" id="Add-station-modal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title">ثبت محدوده</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <hr class="mb-0">


            <!-- <img src="../../../assets/Img/layer-icon.png" title="تغییر نوع نقشه" (click)="changeTail()" class="bg-third index p-2 circel-2 my-1 text-center pointer text-white icon-Img"> -->
            <div id="map" class="position-sticky w-100" style="height: 300px;">
                <div class="position-absolute" id="map_tooltip" data-bs-html="true">
                </div>

            </div>

            <div class="modal-footer dirI d-flex justify-content-between">
                <button class="btn btn-warning w-fit" title="تغییر نوع نقشه" (click)="changeTail()">تغییر نوع نقشه <i class="fa fa-map-marker"></i></button>
            </div>
        </div>
    </div>
</div>




<!-- Modal Insert -->
<div class="modal fade" id="addModal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-xl dirI">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="">ثبت تبلیغات</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="d-flex col-12 dirI flex-wrap" [formGroup]="saveAdd">

                    <div class="col-xl-3 col-lg-4 col-6">
                        <div class="col-11 mx-auto">
                            <label> متقاضی *</label>
                            <input type="text" class="form-control" formControlName="strApplicant">

                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-6">
                        <div class="col-11 mx-auto">
                            <label> عنوان </label>
                            <input type="text" class="form-control" formControlName="strSubject">

                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-6">
                        <div class="col-11 mx-auto">
                            <label> تاریخ شروع </label>
                            <form [formGroup]="datatFrom">
                                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                                    <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                                </ng-persian-datepicker>
                            </form>

                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-6">
                        <div class="col-11 mx-auto">
                            <label> تاریخ پایان </label>
                            <form [formGroup]="datatTo">
                                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                                    <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                                </ng-persian-datepicker>
                            </form>

                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-6">
                        <div class="col-11 mx-auto">

                            <label class="w-100"> ساعت شروع </label>
                            <div class="input-group clockpicker">

                                <input type="text" class="form-control shadow bg-light" value="00:00" id="Stime" readonly>
                                <span class="input-group-addon ">
                                <span class="glyphicon glyphicon-time"></span>
                                </span>

                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-6">
                        <div class="col-11 mx-auto ">

                            <label class="w-100"> ساعت پایان </label>
                            <div class="input-group clockpicker">
                                <input type="text" class="form-control shadow bg-light" value="23:59" id="Etime" readonly>
                                <span class="input-group-addon ">
                    <span class="glyphicon glyphicon-time"></span>
                                </span>
                            </div>



                        </div>
                    </div>

                    <div class="col-xl-3 col-lg-4 col-6">
                        <div class="col-11 mx-auto">
                            <label class="mb-2"> حوزه خدمت</label>

                            <select class="form-select" id="domainDashbord" formControlName="iMobileDomain">
                          <option value="-1">انتخاب کنید</option>
                          <option *ngFor="let item of domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>
                      </select>

                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-6">
                        <div class="col-11 mx-auto">
                            <label class="mb-2">گروه خودرو</label>

                            <select id="carGroup" class="form-select" formControlName="tiMobileGroup">
                    <option value="-1">نمایش همه</option>
                    <option *ngFor="let item of groupCar" value="{{item.tiMobileGroup}}">{{item.strComment}}</option>
                </select>

                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-6">
                        <div class="col-11 mx-auto">

                            <label class="mb-2">نوع خودرو</label>
                            <select class="form-select" id="carType" formControlName="tiGPSType">
                            <option value="-1" selected>انتخاب کنید</option>
                            <option *ngFor="let item of carType" value="{{item.tiGPSType}}">
                                {{item.strComment}}
                            </option>
                        </select>

                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-6">
                        <div class="col-11 mx-auto">
                            <label> هزینه پایه هر بار پخش </label>
                            <input type="text" class="form-control" (keypress)="seprator($event)" form>

                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-6">
                        <div class="col-11 mx-auto">
                            <label> درصد افزایش به ازای هر مسافر </label>
                            <input type="text" class="form-control" [maxLength]="2" (keypress)="seprator($event)">

                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-6">
                        <div class="col-11 mx-auto">
                            <label> حداکثر تعداد پخش *</label>
                            <input formControlName="iMaxPlay" type="text" class="form-control" [maxLength]="5" (keypress)="seprator($event)">

                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-6">
                        <div class="col-11 mx-auto">
                            <label> مدت زمان پخش *</label>
                            <input type="number" class="form-control" formControlName="iDuration">

                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-6 d-flex align-items-center">
                        <div class="col-11 mx-auto ">
                            <label for="bMusic">موزیک است</label>
                            <input type="checkbox" formControlName="bMusic" class="form-check-input" id="bMusic">

                        </div>
                    </div>
                    <div class="col-12 d-flex justify-content-center">
                        <button class="btn btn-primary mt-2 mx-auto" *ngIf="!isEdite" (click)="save()">ذخیره</button>
                        <button class="btn btn-warning mt-2 mx-auto" *ngIf="isEdite" (click)="edit()">ویرایش</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>